import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import React, { useEffect, useState } from 'react';
import { collection, doc, onSnapshot, updateDoc, getDoc, getDocs } from 'firebase/firestore';
import { db } from '../lib/firebaseConfig';
import DataVisualisation from './DataVisualisation';
import './HomeComponent.css';
import UserData from './UserData';
import { useCustomerPortal } from '../hooks/payment';
import TopUp from './TopUp';
import Modal from '@mui/material/Modal';


function HomeComponent() {
  const { goToBillingPortal } = useCustomerPortal();
  const subscription = JSON.parse(localStorage.getItem('subscription'));

  const [totalUsers, setTotalUsers] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [averageSessionLength, setAverageSessionLength] = useState('');
  const [tokenLeft, setTokenLeft] = useState('');
  const [isTopUpOpen, setIsTopUpOpen] = useState(false); 
  const [userData, setuserData] = useState([]);
  const [messageData, setmessagData] = useState([]);

  const handleTopUpOpen = () => { 
    setIsTopUpOpen(true);
  };

  const handleTopUpClose = () => {
    setIsTopUpOpen(false);
  };

  // const fakeData = [
  //   { day: 'Monday', hour: '09:00', frequency: 10 },
  //   { day: 'Monday', hour: '10:00', frequency: 20 },
  //   { day: 'Monday', hour: '11:00', frequency: 15 },
  //   { day: 'Tuesday', hour: '09:00', frequency: 5 },
  //   { day: 'Tuesday', hour: '10:00', frequency: 25 },                               
  //   { day: 'Tuesday', hour: '11:00', frequency: 30 },
  // ];
useEffect(()=>{
  const unsubscribe = onSnapshot(collection(db, 'chatUsers'), (snapshot) => {
    let activeUsersCount = 0;
    snapshot.forEach((doc) => {
      const userData = doc.data();
      if (userData.isActive) {
        activeUsersCount += 1;
      }
    });
    setActiveUsers(activeUsersCount);
  });
  return () => unsubscribe();
}, []);

  useEffect(() => {
    const fetchAllChatUserData = async () => {
      try {
        const chatUsersQuery = collection(db, 'chatUsers');
        const chatUsersSnapshot = await getDocs(chatUsersQuery);
        const newUser = [];
  
        chatUsersSnapshot.docs.forEach((doc) => {
          const userData = doc.data();
          console.log("user data", userData);
  
          // Extract timestamp
          const timestamp = userData.timestamp ? userData.timestamp.toDate() : null;
  
          // Extract day, date, and time
          const day = timestamp ? timestamp.toLocaleString('en-US', { weekday: 'long' }) : null;
          const date = timestamp ? timestamp.toLocaleDateString() : null;
          const time = timestamp ? timestamp.toLocaleTimeString() : null;
          const month = timestamp ? timestamp.toLocaleString('en-US', { month: 'long' }) : null;
          const hour = timestamp ? timestamp.getHours() : null;
          const year = timestamp ? timestamp.getFullYear() : null;
  
          // Check if the entry already exists in the newUser array
          const existingIndex = newUser.findIndex(
            (entry) => entry.day === day && entry.date === date && entry.hour === hour && entry.year === year
          );
  
          if (existingIndex !== -1) {
            // If the entry exists, increment the frequency by 1
            newUser[existingIndex].frequency_user += 1;
          } else {
            // If the entry doesn't exist, add a new entry with a frequency of 1
            newUser.push({
              day: day,
              date: date,
              time: time,
              month: month,
              hour: hour,
              year: year,
              frequency_user: 1,
            });
          }
        });
  
        setuserData(newUser);
      } catch (error) {
        console.error('Error fetching chat user data:', error);
      }
    };
  
    fetchAllChatUserData();
  }, []);
    
  useEffect(() => {
    const fetchMessageFrequency = async () => {
      try {
        const chatUsersQuery = collection(db, 'chatUsers');
        const chatUsersSnapshot = await getDocs(chatUsersQuery);
        const message_user = [];
  
        chatUsersSnapshot.forEach(async (userDoc) => {
          const messagesCollection = collection(userDoc.ref, 'messages');
          const messagesSnapshot = await getDocs(messagesCollection);
  
          messagesSnapshot.forEach((messageDoc) => {
            const { timestamp } = messageDoc.data();
  
            // Extract day, date, and time
            const day = timestamp ? timestamp.toDate().toLocaleString('en-US', { weekday: 'long' }) : null;
            const hour = timestamp ? timestamp.toDate().getHours() : null;
            const date = timestamp ? timestamp.toDate().toLocaleDateString() : null;
            const month = timestamp ? timestamp.toDate().toLocaleString('en-US', { month: 'long' }) : null;
            const year = timestamp ? timestamp.toDate().getFullYear() : null;
  
            // Check if the entry already exists in the message_user array
            const existingIndex = message_user.findIndex(
              (entry) => entry.day === day && entry.date === date && entry.hour === hour && entry.year === year
            );
  
            if (existingIndex !== -1) {
              // If the entry exists, increment the frequency by 1
              message_user[existingIndex].frequency += 1;
            } else {
              // If the entry doesn't exist, add a new entry with a frequency of 1
              message_user.push({
                day: day,
                date: date,
                time: timestamp.toDate().toLocaleTimeString(), // Adjust as needed
                month: month,
                hour: hour,
                year: year,
                frequency: 1,
              });
            }
          });
        });
        console.log("the message freq is", message_user);
        // Set the updated message_user array
        setmessagData(message_user);
      } catch (error) {
        console.error('Error fetching message frequency:', error);
      }
    };
  
    fetchMessageFrequency();
  }, []);
  


  const updateStatisticsData = async () => {
    try {
      // Fetch the total number of entries in 'chatUsers' collection
      const chatUsersQuery = collection(db, 'chatUsers');
      const chatUsersSnapshot = await getDocs(chatUsersQuery);
      
      const totalUsersCount = chatUsersSnapshot.size;
          // Fetch the number of active users
      // const activeUsersQuery = collection(db, 'chatUsers').where('isActive', '==', true);
      // const activeUsersSnapshot = await getDocs(activeUsersQuery);
      // const activeUsersCount = activeUsersSnapshot.size;

      const statisticsDataRef = doc(db, 'statistics', 'stats_2023');
      const statisticsDataSnapshot = await getDoc(statisticsDataRef);
      const statisticsData = statisticsDataSnapshot.data();

      // Mettez à jour les valeurs des champs souhaités
      const updatedStatisticsData = {
        ...statisticsData,
        totalUsers: totalUsersCount, // Nouvelle valeur pour totalUsers
        averageSessionLength: statisticsData.averageSessionLength, // Nouvelle valeur pour averageSessionLength
        tokenLeft: statisticsData.tokenLeft, // Nouvelle valeur pour tokenLeft
        // activeUsers:activeUsersCount
      };

      await updateDoc(statisticsDataRef, updatedStatisticsData);
      console.log('Statistics data updated successfully!');
    } catch (error) {
      console.error('Error updating statistics data:', error);
    }
  };

  useEffect(() => {
    // Appel de la fonction updateStatisticsData() au moment approprié pour mettre à jour les statistiques
    updateStatisticsData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const statisticsDataRef = doc(db, 'statistics', 'stats_2023');
        const statisticsDataSnapshot = await getDoc(statisticsDataRef);
        const statisticsData = statisticsDataSnapshot.data();

        // Récupérer les données spécifiques à chaque compte admin depuis la collection "statistics"
        setTotalUsers(statisticsData.totalUsers);
        setAverageSessionLength(statisticsData.averageSessionLength);
        setTokenLeft(statisticsData.tokenLeft);
        // setActiveUsers(statisticsData.activeUsers);
      } catch (error) {
        console.error('Erreur lors de la récupération des données de la collection "statistics":', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="HomeComponentContainer">
      <div className="stats-container">
        <div className="stat-box">
          <h3>Total Users</h3>
          <p className="stat-value">{totalUsers}</p>
        </div>
        <div className="stat-box">
          <h3>Active Users</h3>
          <p className="stat-value">{activeUsers}</p>
        </div>
        <div className="stat-box">
          <h3>Average Session Length</h3>
          <p className="stat-value">{averageSessionLength}</p>
        </div>


        <div className="stat-box">
          <h3>Token left</h3>
          <p className="stat-value">{tokenLeft}</p>

          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '5px'}}>
          {subscription && (
            <button onClick={goToBillingPortal} style={{ fontSize: '12px', cursor: 'pointer' }}>
              Upgrade
            </button>
          )}

          <Divider orientation="vertical" variant="middle" color="white"/>

          <button onClick={handleTopUpOpen}  style={{ fontSize: '12px', cursor: 'pointer' }}>
            Top-up
          </button>
          </div>

        </div>
      </div>



      <div className="data-row">
        <div style={{ width: '100%', margin: '20px 20px' }}>
          <DataVisualisation data={messageData} />
        </div>
        <div style={{ width: '100%', margin: 'auto 20px' }}>
          <UserData data={userData} />
        </div>
      {isTopUpOpen && ( // si isTopUpOpen est vrai, afficher la modal
        <Modal open={isTopUpOpen} onClose={handleTopUpClose}>
        <Box sx={{ outline: 'none' }}>
          <TopUp onClose={handleTopUpClose} />
        </Box>
      </Modal>
      )}
      </div>


    </div>
  );
}

export default HomeComponent;
